import { useState, useEffect } from 'react';
import { shouldOpenInLightbox } from './util.should-open-in-lightbox.js';

/**
 * Keeps track of whether or not the embed should currently render the iframe
 * inside of it.
 */
function useShouldRender(args) {
  const [shouldRender, setShouldRender] = useState(() => determineIfShouldRender(args));
  useEffect(() => {
    setShouldRender(determineIfShouldRender(args));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [args.componentRef, args.disabled, args.displayData, args.activatedByInteraction, args.autoActivate, args.forceOpenInLightbox, args.learningObjectId]);
  return shouldRender;
}
function determineIfShouldRender(args) {
  if (args.disabled) {
    return false;
  }

  // The iframe should ever only be rendered in one place, so if it should live
  // inside a lightbox, then it should not be rendered in embed mode.
  if (shouldOpenInLightbox(args)) {
    return false;
  }
  const isStandalone = !!args.learningObjectId && window.location.href.indexOf(`learningObject/${args.learningObjectId}`) !== -1;
  return args.autoActivate || isStandalone || args.activatedByInteraction;
}

export { useShouldRender };
//# sourceMappingURL=hook.should-render.js.map
